// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function areaTypeV5_decode($$enum) {
  if ($$enum === "BLOCK_GROUP" || $$enum === "ZIP_CODE" || $$enum === "CENSUS_PLACE" || $$enum === "TOWNSHIP" || $$enum === "CITY" || $$enum === "STATE" || $$enum === "COUNTY" || $$enum === "SCHOOL_DISTRICT" || $$enum === "NEIGHBORHOOD" || $$enum === "SCHOOL") {
    return $$enum;
  }
}

let areaTypeV5_fromString = areaTypeV5_decode;

let Utils = {
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: areaTypeV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsPreferenceEditDialogAreaGroups_areaGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Area",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": "type_",
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AreaGroupV5",
  "abstractKey": "__isAreaGroupV5"
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
